@if (isLoading()) {
  <elcia-loader/>
} @else {
  <p-table [scrollable]="true" [size]="'small'" [value]="taxes()" scrollHeight="flex" stripedRows>
    <ng-template #header>
      <tr>
        <th pResizableColumn>{{ 'local.french' | translate }}</th>
        <th pResizableColumn>{{ 'tax.rate' | translate }}</th>
        <th pResizableColumn>{{ 'tax.peppol-code' | translate }}</th>
        <th pResizableColumn>{{ 'accounting-account.name' | translate }} 1</th>
        <th pResizableColumn>{{ 'tax.accounting-code' | translate }} 1</th>
        <th pResizableColumn>{{ 'accounting-account.name' | translate }} 2</th>
        <th pResizableColumn>{{ 'tax.accounting-code' | translate }} 2</th>
        <th pResizableColumn>{{ 'tax.is-default' | translate }}</th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template #body let-row>
      <tr (click)="edit(row)" class="cursor-pointer hover:bg-gray-50">
        <td>{{ row.nameFr }}</td>
        <td>{{ row.rate }}%</td>
        <td>{{ row.peppolCode }}</td>
        <td>{{ row.accountingAccountName }}</td>
        <td>{{ row.accountingCode }}</td>
        <td>{{ row.accountingAccount2Name }}</td>
        <td>{{ row.accountingCode2 }}</td>
        <td>
          @if (row.isDefault) {
            <span class="text-primary-500 font-bold">&#10003;</span>
          }
        </td>
        <td class="flex justify-end gap-2">
          <elcia-button (onClick)="delete($event, row)" [icon]="'delete'" [severity]="'danger'" [variant]="'text'"/>
        </td>
      </tr>
    </ng-template>
  </p-table>
}
